import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'local-search',
  templateUrl: './local-search.component.html',
  styleUrls: ['./local-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocalSearchComponent {
  @Input()
  label = '';

  _items: any[] = null;
  @Input()
  get items() {
    return this._items;
  }
  set items(val) {
    this._items = val;
    // this.filterItems(this.searchKey);
  }

  @Input()
  searchKeys: string[] = null;

  @Input()
  field: string = null;

  @Input()
  filter: 'startWith' | 'contains' = 'startWith';

  @Input()
  showDropDown = false;

  @Input()
  class = "";

  @Input()
  disabled = false;

  @Input()
  performance = false;

  @Input()
  placeholder = 'Search here...';

  @Output()
  onSearch = new EventEmitter<string>();

  @Output()
  onItemFiltered = new EventEmitter<any[]>();


  results: any[] = [];
  top100results: any[] = [];

  @Input()
  searchKey = '';

  // @Output()
  // searchKeyChange = new EventEmitter<string>();

  constructor(private cd: ChangeDetectorRef) { }



  search(event) {
    const key = event.query.toLowerCase();
    this.searchKey = event.query;
    if (this.items) {
      this.results = this.filterItems(key);
    }
    else {
      this.results = [];
      this.top100results = [];
      // simple search which only emit the search key
      this.onSearch.next(key);
    }
    this.cd.detectChanges();
  }

  clearSearch() {
    if (this.performance && this.items) {
      this.items.forEach(item => item.filtered = false);
    }
    this.results = this.items || [];
    this.onItemFiltered.next(this.results);
    this.searchKey = '';
    // this.searchKeyChange.emit(this.searchKey);
    this.onSearch.next('');
    this.cd.detectChanges();
  }

  filterItems(key) {
    let results = [];
    if (!key) {
      // if (this.performance) {
      this.items.forEach(item => item.filtered = false);
      // }
      results = this.items;
    }
    else {
      if (this.items && this.items.length > 0) {
        const selectedItem = this.items.find(p => p['selected']);
        // search in provided items
        if (this.searchKeys && this.searchKeys.length > 0) {
          // keys are case sensitive
          const searchKeys = this.searchKeys;//.map(key => key.toLocaleLowerCase());
          results = this.items.filter(item => {
            if (this.filter == 'startWith')
              return searchKeys.some(searchKey => _.get(item, searchKey) && _.get(item, searchKey).toLowerCase().indexOf(key) == 0);
            else {
              return searchKeys.some(searchKey => _.get(item, searchKey) && _.get(item, searchKey).toLowerCase().indexOf(key) >= 0);
            }
          });
          if (this.performance) {
            this.items.forEach(item => {
              item.filtered = true;
              if (item.selected) {
                item.selected = false;
              }
            });
            results.forEach(item => item.filtered = false);
            results = this.items;
          }
        }
        else {
          results = this.items.filter(item => {
            if (this.filter == 'startWith')
              return item.indexOf && item.toLowerCase().indexOf(key) == 0;
            else {
              return item.indexOf && item.toLowerCase().indexOf(key) >= 0;
            }
          });

          if (this.performance) {
            this.items.forEach(item => {
              item.filtered = true;
              if (item.selected) {
                item.selected = false;
              }
            });
            results.forEach(item => item.filtered = false);
            results = this.items;
          }
        }
        if (selectedItem && !results.find(p => p == selectedItem)) {
          selectedItem['selected'] = false;
        }
        // in case the filtered result is to large when startWith
        // always update top100results to hide the loading spin
        if (this.showDropDown) {
          this.top100results = results.slice(0, 100);
        }
        else {
          this.top100results = [];
        }
        // this.onItemFiltered.next(results);
      }
      else {
        results = [];
      }
    }
    this.results = results;
    this.onSearch.next(key);
    this.cd.detectChanges();
    this.onItemFiltered.next(this.results);
    return results;
  }

}
